import { Popover, PopoverButton, PopoverPanel } from "@headlessui/react";
import { classNames } from "../../helpers/classNames";

export default function PopoverDropdown({
  children,
  content,
  buttonLabel = "popover button",
  buttonClass,
  contentClass,
  contentBodyClass,
  position = "bottom",
}) {
  return (
    <Popover>
      {({ open }) => (
        <>
          <PopoverButton
            className={classNames(
              "bg-primary h-10 px-3 py-2 rounded-md text-white",
              open ? "opacity-50" : "",
              buttonClass
            )}
            type="button"
          >
            {buttonLabel}
          </PopoverButton>
          {open && (
            <PopoverPanel
              transition
              anchor={position}
              className={classNames(
                "relative z-0 !overflow-visible",
                "before:content-[''] before:absolute before:!bg-white before:w-4 before:h-4 before:left-1/2 before:right-1/2 before:-translate-x-1/2 before:shadow-lg before:rotate-45 before:-z-[1] before:border before:border-slate-300/50",
                position === "botton"
                  ? "before:top-0 before:left-[92%] before:right-0 before:translate-x-full mt-1"
                  : position === "top"
                  ? "before:-bottom-1 !-mt-1"
                  : position === "left"
                  ? "before:left-[97.5%] before:!bottom-1/2"
                  : position === "right"
                  ? "before:left-0"
                  : "",
                contentBodyClass
              )}
            >
              <div
                className={classNames(
                  "bg-white shadow-md rounded-md min-w-60 max-w-auto relative border border-slate-100 p-3 mt-[5px]",
                  position === "left"
                    ? "mr-2"
                    : position === "right"
                    ? "ml-2"
                    : "",
                  contentClass
                )}
              >
                {children || content}
              </div>
            </PopoverPanel>
          )}
        </>
      )}
    </Popover>
  );
}

// divide-y divide-white/5 rounded-xl bg-white/5 text-sm/6 transition duration-200 ease-in-out [--anchor-gap:--spacing(5)] data-closed:-translate-y-1 data-closed:opacity-0
